import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Grid, Paper, Typography, Button } from "@mui/material";

import dayjs from "dayjs";

import actions from "../../../../store/actions";
import ls from "../../../../Localization";
import { State } from "store/reducers";
import useStyles from "./styles";
import IBankBillet, { BankBilletStatus } from "Types/BankBillet";
import { toStringCurrency } from "helpers/string";
import { SubscriptionDetailState } from "store/reducers/subscription/detail";
import { SubscriptionStatus } from "Types/Subscription";
import IPlan from "Types/Plan";
import { InstallmentStatus } from "Types/Installment";
import IPaymentMethod from "Types/PaymentMethod";
import { useNavigate } from "react-router-dom";

export function SubscriptionDetail({
	match: {
		params: { id }
	}
}: any) {
	const navigate = useNavigate();
	const classes = useStyles({});
	const dispatch = useDispatch<any>();

	useEffect(() => {
		dispatch(actions.subscription.detail.clearValues());
	}, [dispatch]);

	useEffect(() => {
		dispatch(actions.subscription.detail.getSubscription(id));
	}, [dispatch, id]);

	const { item } = useSelector<State, SubscriptionDetailState>(
		s => s.subscriptionDetail
	);

	const handleEdit = () => {
		navigate(`/Dashboard/Subscriptions/${item._id}/Edit`);
	};

	if (!item) return null;

	const {
		createdAt,
		status,
		value,
		user,
		plan,
		installments,
		paymentMethod,
		description,
		installment
	}: any = item;

	const ls2: any = ls;

	return (
		<Grid container justifyContent="center" spacing={5}>
			<Grid item xs={11}>
				<Paper className={classes.root}>
					<div className={classes.header}>
						<Typography variant="h6">{ls.subscriptionData}</Typography>
						<div>
							<Button color="primary" onClick={handleEdit}>
								{ls.edit}
							</Button>
						</div>
					</div>
					<hr className={classes.line} />

					<Grid container spacing={2} className={classes.form}>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.creationDate}</strong>:{" "}
							{dayjs(createdAt).format(ls.dateFormatWithoutSeconds)}
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.user}</strong>: {user?.name} {user?.lastname}
						</Grid>

						<Grid item xs={12} sm={6} md={3} lg={2}>
							<strong>{ls.plan}</strong>: {(plan as IPlan).name}
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={4}>
							<strong>{ls.paymentMethod}</strong>:{" "}
							{(paymentMethod as IPaymentMethod)?.name}
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.value}</strong>: {toStringCurrency(+value / 100.0)}
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.installment}</strong>: {installment}
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.status}</strong>: {ls2[SubscriptionStatus[status]]}
						</Grid>

						<Grid item xs={12}>
							<strong>{ls.description}</strong>: {description ?? "Não definido"}
						</Grid>

						<Grid item xs={12}>
							<strong>{ls.installment}</strong>:
							{installments.map((c: any, i: any) => {
								console.log(InstallmentStatus[c.status]);

								return (
									<Grid container key={i}>
										<Grid item xs={12} sm={4} md={3} lg={2}>
											<strong>{ls.number}</strong>: {c.number}
										</Grid>
										<Grid item xs={12} sm={4} md={4} lg={3}>
											<strong>Data pagamento</strong>:{" "}
											{dayjs(c.paymentDate).format("DD/MM/YYYY")}
										</Grid>
										<Grid item xs={12} sm={4} md={4} lg={3}>
											<strong>{ls.status}</strong>:{" "}
											{c.transaction ? (
												(c.transaction as IBankBillet)?.status ===
												BankBilletStatus.pending ? (
													<a
														href={(c.transaction as IBankBillet).url}
														target="_blank"
													>
														Aguardando pagamento
													</a>
												) : (
													""
												)
											) : (
												ls2[InstallmentStatus[c.status]]
											)}
										</Grid>
									</Grid>
								);
							})}
						</Grid>
					</Grid>
				</Paper>
			</Grid>
		</Grid>
	);
}

export default SubscriptionDetail;
